const defaultTagData =
  '{"tem_data":[{"type":"FixedText","data":{"text":"订单号：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_1","fontPt":8,"hasControls":false,"left":343.66666666666674,"top":294.83333333333326,"splitByGrapheme":false,"width":40,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"成品尺寸：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_2","fontPt":8,"hasControls":false,"left":343.00000000000006,"top":348.1111111111111,"splitByGrapheme":false,"width":54.4287109375,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"板号：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_6","fontPt":8,"hasControls":false,"left":426.0241121886174,"top":308.46695774430384,"splitByGrapheme":false,"width":30,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"板件名称：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_11","fontPt":8,"hasControls":false,"left":342.6111111111112,"top":334.77777777777777,"splitByGrapheme":false,"width":50,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"安装图","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_14","fontPt":8,"hasControls":false,"left":341.83333333333337,"top":408.1111111111112,"splitByGrapheme":false,"width":30,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"材质：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_18","fontPt":8,"hasControls":false,"left":343.25,"top":361.75,"splitByGrapheme":false,"width":30,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"房间: ","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_20","fontPt":8,"hasControls":false,"left":343,"top":321.75,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"柜体:","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_21","fontPt":8,"hasControls":false,"left":415.903446072807,"top":321.4862084063937,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"FixedText","data":{"text":"项目地址：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_26","fontPt":8,"hasControls":false,"left":343.6617818128668,"top":280.81634365807565,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"北京市东城区东长安街","lineHeight":1,"fontSize":9,"fontWeight":"","item_id":"DataSource_27","fontPt":8,"hasControls":false,"left":391.3053950994068,"top":282.482729007438,"width":90,"height":10.169999999999998,"rectWidth":100,"rectHeight":11,"isAutoFontSize":true,"source_data":"address","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"第1 张大板","lineHeight":1,"fontSize":10,"fontWeight":"bold","item_id":"DataSource_15","fontPt":8,"hasControls":false,"left":505.78024021012834,"top":386.8869570794475,"width":47.430000686645506,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"plank_index","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"客户：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_0","fontPt":8,"hasControls":false,"left":343.53731532100517,"top":308.54319531249547,"splitByGrapheme":false,"width":30,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"0001-01","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_4","fontPt":8,"hasControls":false,"left":381,"top":295.3888888888888,"width":38.069999694824226,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"orderNo","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"张某某","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_3","fontPt":8,"hasControls":false,"left":371.4800550045915,"top":308.65430642360667,"width":30,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"customer_name","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"11#","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_17","fontPt":8,"hasControls":false,"left":452.7181777973155,"top":308.7729547371115,"width":14.01999969482422,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"plankID","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"衣柜","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_23","fontPt":8,"hasControls":false,"left":440.5432511722703,"top":321.6159943234146,"width":20,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"loc","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"主卧","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_22","fontPt":8,"hasControls":false,"left":368.75,"top":321.75,"width":20,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"roomName","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"横隔板01","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_10","fontPt":8,"hasControls":false,"left":389.61111111111114,"top":335.3333333333333,"width":40.00999984741211,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"partName","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"多层实木","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_19","fontPt":8,"hasControls":false,"left":371.7498105821269,"top":362.25,"width":40,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"matCode_texture","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"2440X1220X18","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_5","fontPt":8,"hasControls":false,"left":390.90597440786576,"top":349.24089702813205,"width":68.75999908447267,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"oSize","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"Typography","data":{"imgItem":{"left":10,"top":10,"mWidth":15,"mHeight":25},"textItems":[{"positionName":"LE","top":47.245,"left":0,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"BE","top":94.49,"left":28.345,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"RE","top":47.245,"left":56.69,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"TE","top":0,"left":28.345,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"}],"hasControls":false,"item_id":"Typography_9","left":497.2222222222223,"top":280.66666666666663,"mHeight":28,"mWidth":17,"scaleX":1.1333568530605045,"scaleY":1.120012699756588,"width":56.69,"height":94.49,"plankRotate":false,"showOpenDoor":true,"showEdgeOff":false,"showEdgeDisplay":false}},{"type":"QRcode","data":{"width":320,"height":324,"hasControls":false,"item_id":"QRcode_12","left":342.6111111111112,"top":376.49999999999994,"source_data":"ggid","mHeight":8,"mWidth":8,"scaleX":0.0945,"scaleY":0.09333333333333332,"isQRcodeNCSuffix":true,"QRCodeFormat":"QRCode"}},{"type":"Onecode","data":{"width":116.4098712913234,"height":39.47103233800499,"hasControls":true,"item_id":"Onecode_13","left":379.7508284454223,"top":377.5916541124726,"mHeight":10.44,"mWidth":30.8,"showCode":true,"Xscale":1,"Yscale":1,"isOnecodeNCSuffix":true,"fontPt":"9","lineHeight":1,"fontWeight":"normal","fontSize":12,"code_type":"CODE128","source_data":"oriPlankNum","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"第1/10页","lineHeight":1,"fontSize":8,"fontWeight":"bold","item_id":"DataSource_16","fontPt":7,"hasControls":false,"left":512.2789142850163,"top":403.1621591113036,"width":31.360000000000003,"height":9.04,"rectWidth":35,"rectHeight":10,"isAutoFontSize":true,"source_data":"lable_index","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}}],"tag_width":60,"tag_height":40,"rectInfo":{"left":336.615,"top":274.40999999999997},"surplus_tem_data":[{"type":"FixedText","data":{"text":"板件材质：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_1","fontPt":8,"hasControls":false,"left":343.66666666666674,"top":281.83333333333326,"splitByGrapheme":false,"width":50,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"多层实木","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_4","fontPt":8,"hasControls":false,"left":391.61111111111114,"top":281.3888888888888,"width":40,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"matCode","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"板件颜色: ","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_20","fontPt":8,"hasControls":false,"left":344.9983922018183,"top":302.73897800009536,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"T01","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_22","fontPt":8,"hasControls":false,"left":393.60950331292946,"top":302.73897800009536,"width":16.19999923706055,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"texture","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"板件尺寸：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_11","fontPt":8,"hasControls":false,"left":343.6103072120204,"top":322.75389677798444,"splitByGrapheme":false,"width":50,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"2440X1220X18","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_10","fontPt":8,"hasControls":false,"left":392.61030721202036,"top":323.30945233354,"width":68.75999908447267,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"oSize","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"余料条码: ","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_23","fontPt":8,"hasControls":false,"left":344.9983922018183,"top":340.73897800009536,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"6570000000000","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_11","fontPt":8,"hasControls":false,"left":392.61030721202036,"top":340.30945233354,"width":68.75999908447267,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"oriPlankNum","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"微信扫一扫，余料即入库","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_14","fontPt":8,"hasControls":false,"left":341.83333333333337,"top":407.1111111111112,"splitByGrapheme":false,"width":110,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"第1 张大板","lineHeight":1,"fontSize":10,"fontWeight":"bold","item_id":"DataSource_15","fontPt":8,"hasControls":false,"left":510.2777777777778,"top":383.3888888888888,"width":47.430000686645506,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"plank_index","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"第1/10页","lineHeight":1,"fontSize":10,"fontWeight":"bold","item_id":"DataSource_16","fontPt":8,"hasControls":false,"left":515.7777777777776,"top":399.6666666666667,"width":39.2,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"lable_index","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"Marking","data":{"item_id":"Marking_50","left":404.66554906903536,"top":362.24148349749066,"field":"wardrobeNum","fontWeight":"bold","radius":18.9,"mRadius":10,"fontPt":10,"fontSize":13,"roomSortWay":"letters"}},{"type":"QRcode","data":{"width":400,"height":404,"hasControls":false,"item_id":"QRcode_12","left":344.6109536553598,"top":356.03398449970587,"source_data":"restockingCode","mHeight":12,"mWidth":12,"scaleX":0.113375,"scaleY":0.11225247524752476,"isQRcodeNCSuffix":true,"QRCodeFormat":"QRCode"}},{"type":"Typography","data":{"imgItem":{"left":10,"top":10,"mWidth":15,"mHeight":25},"textItems":[{"positionName":"LE","top":47.245,"left":0,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"BE","top":94.49,"left":28.345,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"RE","top":47.245,"left":56.69,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"TE","top":0,"left":28.345,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"}],"hasControls":false,"item_id":"Typography_9","left":505.7238755076107,"top":287.16666666666663,"mHeight":25,"mWidth":15,"scaleX":1,"scaleY":1,"width":56.69,"height":94.49,"plankRotate":false,"showOpenDoor":true,"showEdgeOff":false,"showEdgeDisplay":false}}],"surplus_waste_data":[{"type":"FixedText","data":{"text":"板件材质：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_1","fontPt":8,"hasControls":false,"left":343.66666666666674,"top":281.83333333333326,"splitByGrapheme":false,"width":50,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"多层实木","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_4","fontPt":8,"hasControls":false,"left":391.61111111111114,"top":281.3888888888888,"width":40,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"matCode","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"板件颜色: ","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_20","fontPt":8,"hasControls":false,"left":344.9983922018183,"top":302.73897800009536,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"T01","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"DataSource_22","fontPt":8,"hasControls":false,"left":393.60950331292946,"top":302.73897800009536,"width":16.19999923706055,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"texture","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"FixedText","data":{"text":"微信扫一扫，余料即入库","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"FixedText_14","fontPt":8,"hasControls":false,"left":341.83333333333337,"top":407.1111111111112,"splitByGrapheme":false,"width":110,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑"}},{"type":"DataSource","data":{"text":"第1 张大板","lineHeight":1,"fontSize":10,"fontWeight":"bold","item_id":"DataSource_15","fontPt":8,"hasControls":false,"left":510.2777777777778,"top":383.3888888888888,"width":47.430000686645506,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"plank_index","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"DataSource","data":{"text":"第1/10页","lineHeight":1,"fontSize":10,"fontWeight":"bold","item_id":"DataSource_16","fontPt":8,"hasControls":false,"left":515.7777777777776,"top":399.6666666666667,"width":39.2,"height":11.299999999999999,"rectWidth":80,"rectHeight":11.3,"isAutoFontSize":true,"source_data":"lable_index","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","statisticsDimension":"noLimit"}},{"type":"Marking","data":{"item_id":"Marking_50","left":404.66554906903536,"top":362.24148349749066,"field":"wardrobeNum","fontWeight":"bold","radius":18.9,"mRadius":10,"fontPt":10,"fontSize":13,"roomSortWay":"letters"}},{"type":"QRcode","data":{"width":400,"height":404,"hasControls":false,"item_id":"QRcode_12","left":344.6109536553598,"top":356.03398449970587,"source_data":"restockingCode","mHeight":12,"mWidth":12,"scaleX":0.113375,"scaleY":0.11225247524752476,"isQRcodeNCSuffix":true,"QRCodeFormat":"QRCode"}},{"type":"Typography","data":{"imgItem":{"left":10,"top":10,"mWidth":15,"mHeight":25},"textItems":[{"positionName":"LE","top":47.245,"left":0,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"BE","top":94.49,"left":28.345,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"RE","top":47.245,"left":56.69,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"},{"positionName":"TE","top":0,"left":28.345,"fontSize":8,"fontPt":8,"fontWeight":"","fontFamily":"微软雅黑"}],"hasControls":false,"item_id":"Typography_9","left":505.7238755076107,"top":287.16666666666663,"mHeight":25,"mWidth":15,"scaleX":1,"scaleY":1,"width":56.69,"height":94.49,"plankRotate":false,"showOpenDoor":true,"showEdgeOff":false,"showEdgeDisplay":false}}],"sub_tem_data":[{"type":"FixedText","data":{"text":"小板副标签（示例）","lineHeight":1,"fontSize":18,"fontWeight":"","item_id":"EibtWlhXNuql9_xCc82Tf","fontPt":14,"hasControls":true,"left":349.3,"top":289.29,"splitByGrapheme":false,"width":174.61,"height":20.339999999999996,"textAlign":"left","fontFamily":"微软雅黑","opacity":1}},{"type":"FixedText","data":{"text":"———————注意二次加工！———————","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"WWtmqkcLCodijsSx7egxD","fontPt":8,"hasControls":true,"left":338.3,"top":401.79,"splitByGrapheme":false,"width":316.82,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑","opacity":1}},{"type":"FixedText","data":{"text":"小板特殊工艺描述：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"AV-i4AtzyilvRakPJdY0I","fontPt":8,"hasControls":true,"left":352.3,"top":333.68,"splitByGrapheme":false,"width":109.345703125,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑","opacity":1,"language":"zh"}},{"type":"DataSource","data":{"text":"无","lineHeight":1,"fontSize":16,"fontWeight":"","item_id":"u6-qFdd6YM3I3cO5QPS0N","fontPt":12,"hasControls":true,"left":458.96000000000004,"top":329.53999999999996,"width":16,"height":18.08,"rectWidth":24.324501772030818,"rectHeight":20.08,"source_data":"process_label","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","opacity":1}},{"type":"FixedText","data":{"text":"小板备注信息：","lineHeight":1,"fontSize":10,"fontWeight":"","item_id":"yJBXZc_UMpJMnfmSVIEez","fontPt":8,"hasControls":true,"left":367.3,"top":372.18000000000006,"splitByGrapheme":false,"width":70,"height":11.299999999999999,"textAlign":"left","fontFamily":"微软雅黑","opacity":1,"language":"zh"}},{"type":"DataSource","data":{"text":"板件备注","lineHeight":1,"fontSize":16,"fontWeight":"","item_id":"adI7MZWJxAoMLz0NvxBHw","fontPt":12,"hasControls":true,"left":459.91,"top":368.79,"width":64,"height":18.08,"rectWidth":64,"rectHeight":18,"source_data":"plank_remarks","textBackgroundColor":"#F6F6F6","fontFamily":"微软雅黑","opacity":1}}]}'

export default defaultTagData

/** 小板副标签默认画布模板（与 defaultTagData 内 sub_tem_data 一致） */
export const subTagDefaultTemData = JSON.parse(defaultTagData).sub_tem_data

/** 补充默认的参数，避免前端添加的数据，后续的标签不存在 */
export const ensureTagDataDefaults = (
  current,
  fields = ['tem_data', 'surplus_data', 'surplus_waste_data', 'sub_tem_data']
) => {
  const originalData = JSON.parse(defaultTagData)
  fields.forEach((field) => {
    if (!current[field] || current[field]?.length === 0) {
      if (field == 'surplus_data') {
        current[field] = originalData[field] ?? originalData['surplus_tem_data']
      } else {
        current[field] = originalData[field]
      }
    }
  })
  return current
}

export const defaultPaibanImgTemplate = {
  width: 793,
  height: 1122,
  imageNamePrefix: 'M',
  imageFormat: 'jpg',
  bigPlank: {
    rotate: '0°',
    fontFamily: '微软雅黑',
    lineSpace: 1,
    fontSize: 8,
    fontWeight: 'normal',
    code: {
      label_keys: {
        '{大板序号}': 'canvasIndex',
        '{大板利用率}': 'usedRate',
        '{板件材质}': 'matCode',
        '{板件颜色}': 'texture',
        '{大板规格}': 'size',
      },
      template_string:
        '第{大板序号}张大板  利用率：{大板利用率}\n材质：{板件材质}  颜色：{板件颜色}  规格：{大板规格}',
    },
  },
  part: {
    fontFamily: '微软雅黑',
    lineSpace: 1,
    fontSize: 8,
    fontWeight: 'normal',
    showOverflow: false,
    showHoleSlot: true,
    code: {
      label_keys: {
        '{板件名称}': 'partName',
        '{切割尺寸}': 'realRect',
      },
      template_string: '{板件名称}\n{切割尺寸}',
    },
  },
}

export const defaultPaibanData = [
  {
    thick: '18.9',
    matCode: '多层实木',
    texture: 'T01',
    stockNum: 1,
    surplusInfo: { plankNum: 6570000000000, other_plate: true },
    margin: 3,
    stockKey: 'T01:多层实木:18.9:1',
    parts: [
      {
        colorRes: {
          loc: '#FFDBB1',
          orderNo: '#C4EEAA',
          roomName: '#EFD374',
        },
        index: 1,
        rect: { x: 0, y: 0, width: 605.5, height: 998.05 },
        rotate: false,
        startX: -1,
        startY: 1242.95,
        stockNum: 1,
        surplusInfo: null,
        priority: 1,
        cutOrigin: 'rightTop',
        otherPlate: null,
        oRect: { x: 0, y: 0, width: 600, height: 991.45 },
        texDir: 'normal',
        loc: '地柜A',
        name: '左立板01',
        plankID: 1,
        partName: '客厅_地柜A_左立板01',
        realCurve: [
          { x: 0, y: 0 },
          { x: 600, y: 0 },
          { x: 600, y: 991.45 },
          { x: 0, y: 991.45 },
        ],
        realCurveEx: [],
        thick: 18.9,
        texture: 'T01',
        matRotatable: false,
        roomName: '客厅',
        roomID: 3000000,
        designer: '',
        holes: [
          {
            type: 'hole',
            deep: 10,
            side: 1,
            center: { x: 59.30000001192093, y: 500.52918043184286 },
            ocenter: { x: 56, y: 497.22918041992193 },
            diameter: 10,
            holeType: 'preHole',
            symbol: '3in1Lock',
          },
          {
            type: 'hole',
            deep: 10,
            side: 1,
            center: { x: 315.30000001192093, y: 500.52918043184286 },
            ocenter: { x: 312, y: 497.22918041992193 },
            diameter: 10,
            holeType: 'preHole',
            symbol: '3in1Lock',
          },
          {
            type: 'hole',
            deep: 10,
            side: 1,
            center: { x: 571.3000000119209, y: 500.52918043184286 },
            ocenter: { x: 568, y: 497.22918041992193 },
            diameter: 10,
            holeType: 'preHole',
            symbol: '3in1Lock',
          },
        ],
        hingeInfo: [],
        slots: [],
        sholes: [],
        sslots: [],
        plankNum: '6570000000000',
        matCode: '多层实木',
        oriPlankNum: '6570000000000',
        hsInfo: '3孔0槽',
        handle: null,
        partsChildren: null,
        remark1: '',
        remark2: '',
        remark3: '',
        installNum: '',
        hasOriPlankNum: true,
        plankNumType2: '6570000-00-0000',
        realRect: { x: 0, y: 0, width: 597.5, height: 990.05 },
        specHeight: '991.45',
        specWidth: '600',
        fullSize: { width: 600, height: 991.45 },
        edgeInfo: '←1↓2→3↑4',
        edge_texture_map: {
          1: 'T01',
          2: 'T02',
          3: 'T03',
          4: 'T04',
        },
        sholeInfo: '',
        sslotInfo: '',
        ggid: 'http://eggi.cn/÷utrl001',
        remark: '',
        customer_name: '',
        address: '孔距边测试',
        orderNo: '220706-513',
        needRoll: false,
        oriHoles: [
          {
            type: 'hole',
            deep: 10,
            side: 1,
            center: { x: 59.30000001192093, y: 500.52918043184286 },
            ocenter: { x: 56, y: 497.22918041992193 },
            diameter: 10,
            holeType: 'preHole',
            symbol: '3in1Lock',
          },
          {
            type: 'hole',
            deep: 10,
            side: 1,
            center: { x: 315.30000001192093, y: 500.52918043184286 },
            ocenter: { x: 312, y: 497.22918041992193 },
            diameter: 10,
            holeType: 'preHole',
            symbol: '3in1Lock',
          },
          {
            type: 'hole',
            deep: 10,
            side: 1,
            center: { x: 571.3000000119209, y: 500.52918043184286 },
            ocenter: { x: 568, y: 497.22918041992193 },
            diameter: 10,
            holeType: 'preHole',
            symbol: '3in1Lock',
          },
        ],
        oriSlots: [],
        oriSholes: [],
        oriSslots: [],
        stockKey: 'T01:多层实木:18.9:1',
        plankWidth: 1200,
        plankHeight: 2240,
        simplePlankNum: '801-5',
        simplePlankNumF: '801-5K',
        type: 'Plank',
        depth: 10,
        holeSlotMerge: false,
        // 自定义特殊标签在模板中体现
        specTagTemplate: 'triangle_shape',
        polyArr: [
          [
            { X: -1, Y: 1242.95 },
            { X: 604.5, Y: 1242.95 },
            { X: 604.5, Y: 2241 },
            { X: -1, Y: 2241 },
          ],
        ],
        plankMerge: false,
        connection_types: {
          front: '',
          top: '三合一',
          back: '',
          bottom: '隐形件',
        },
        specialFlag: 'triangle_shape',
        plank_remarks: '板件备注',
        handle: { partsChildren: [{ maskPartName: '单孔', name: '拉手' }] },
        process_label: {
          auto_label: [
            {
              lastCurve: '异形',
            },
          ],
          custom_label: [],
        },
      },
    ],
    plankWidth: 1200,
    plankHeight: 2240,
    otherPlate: null,
    usedRate: 0.24474731580912623,
    usedArea: 0,
    bigPlank: [
      [
        { X: -1, Y: -1 },
        { X: 1201, Y: -1 },
        { X: 1201, Y: 2241 },
        { X: -1, Y: 2241 },
      ],
    ],
    sideType: 1,
    ableToggle: false,
    _sortNum: 1,
    height: 373.3333333333333,
    width: 200,
    startX: 30,
    startY: 0,
    canvasIndex: 1,
    path: [
      { x: 0, y: 0 },
      { x: 1200, y: 0 },
      { x: 1200, y: 2240 },
      { x: 0, y: 2240 },
      { x: 0, y: 0 },
    ],
  },
]

export const drillDefaultData = {
  '{项目地址}': '北京市东城区东长安街天安门广场',
  '{订单编号}': '222',
  '{订单创建时间}': '2020-10-11 19:28:52',
  '{订单创建日期}': '2020-10-11',
  '{客户名称}': '张某某',
  '{设计师}': '李设计',
  '{房间}': '主卧',
  '{柜体}': '衣柜',
  '{板件名称}': '横隔板01',
  '{板件条码}': '0000123456789',
  '{板件打孔码}': '0000123456789',
  '{板件打包码}': 'http://eggi.cn/÷a000001',
  '{板件编号}': '11#',
  '{板件编码}': '11#',
  '{板件纹理}': '横纹',
  '{板件成品长度}': '2440',
  '{板件成品宽度}': '1220',
  '{板件打包码（转义）}': 'http://eggi.cn/%C3%B7a000001',
  '{板件厚度}': '18',
  '{板件材质}': '多层实木',
  '{板件颜色}': 'T01',
  '{大板厚度}': '18',
  '{大板材质}': '多层实木',
  '{大板颜色}': 'T01',
  '{大板长度}': '2750',
  '{大板宽度}': '1220',
  '{前封边}': '1.0',
  '{后封边}': '1.0',
  '{左封边}': '1.0',
  '{右封边}': '1.0',
  '{孔起点X坐标}': '0',
  '{孔起点Y坐标}': '0',
  '{孔起点Z坐标}': '0',
  '{孔终点X坐标}': '100',
  '{孔终点Y坐标}': '100',
  '{孔终点Z坐标}': '9',
  '{孔直径}': '15',
  '{孔深度}': '10',
  '{槽起点X坐标}': '0',
  '{槽起点Y坐标}': '0',
  '{槽起点Z坐标}': '0',
  '{槽中心点X坐标}': '25',
  '{槽中心点Y坐标}': '25',
  '{槽中心点Z坐标}': '25',
  '{槽终点X坐标}': '50',
  '{槽终点Y坐标}': '50',
  '{槽终点Z坐标}': '9',
  '{槽底Z坐标}': '9',
  '{槽底中心Z坐标}': '9',
  '{槽宽度}': '10',
  '{槽深度}': '10',
  '{槽长度}': '50',
  '{轮廓起点X坐标}': '0',
  '{轮廓起点Y坐标}': '0',
  '{轮廓起点Z坐标}': '0',
  '{常规点X坐标}': '100',
  '{常规点Y坐标}': '100',
  '{常规点Z坐标}': '0',
  '{异形起点X坐标}': '200',
  '{异形起点Y坐标}': '200',
  '{异形起点Z坐标}': '0',
  '{异形终点X坐标}': '200',
  '{异形终点Y坐标}': '200',
  '{异形终点Z坐标}': '0',
  '{异形圆弧半径}': '100',
  '{轮廓终点X坐标}': '300',
  '{轮廓终点Y坐标}': '300',
  '{轮廓终点Z坐标}': '0',
  '{生成轮廓序号}': '0',
  '{生成孔槽序号}': '1',
  '{轮廓X坐标}': '0',
  '{轮廓Y坐标}': '0',
  '{轮廓Z坐标}': '0',
  '{圆弧半径}': '10',
  '{圆弧方向}': '内凹',
  '{上一轮廓X坐标}': '1',
  '{上一轮廓Y坐标}': '2',
  '{上一轮廓Z坐标}': '3',
  '{内外轮廓编号}': '1',
  '{横竖槽标识}': '横槽',
  '{上一条边封边厚度}': '1',
  '{孔槽是否加工标识}': '是',
  '{双面加工标识}': '双面加工标识',
  '{正面下料文件名}': '18多层实木T01-Z',
  '{上下边放量}': '2',
  '{左右边放量}': '2',
  '{轮廓序号总数}': '0',
}

const ban = `
<MicroDrawBan_XML Version="3.0" Time="2021/04/23 上午 10:26:7" Source="柜柜软件" SourceType="BAN">
<Plane Width="600" Hight="512.32" Code1="" PlaneSize="1" Grain="2" Thickness="18" Material="多层实木" EdgeFBLR="0.5,0.5,0.5,1.5" Name="主卧_地柜A_横隔板01" Code="5#">
    <Outline>
        <Point Value="0 0 0"/>
        <Point Value="600 0 0"/>
        <Point Value="600 512.32 0"/>
        <Point Value="0 512.32 0"/>
        <Point Value="0 0 0"/>
    </Outline>
    <HoleV Name="" Diameter="15" IsCuted="0" Face="A" Start="500 479.32 0" End="500 479.32 -14"/>
    <HoleV Name="" Diameter="15" IsCuted="0" Face="A" Start="308 479.32 0" End="308 479.32 -14"/>
    <HoleV Name="" Diameter="15" IsCuted="0" Face="A" Start="116 479.32 0" End="116 479.32 -14"/>
    <HoleH Name="" Diameter="8" IsCuted="0" Face="U" Start="500 512.32 -9" End="500 479.32 -9"/>
    <HoleH Name="" Diameter="8" IsCuted="0" Face="U" Start="308 512.32 -9" End="308 479.32 -9"/>
    <HoleH Name="" Diameter="8" IsCuted="0" Face="U" Start="116 512.32 -9" End="116 479.32 -9"/>
    <SlotL Name="" Face="B" Start="20.5 512.32 -12.5" End="20.5 0 -12.5" Width="5" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="20.5 512.32 -5.5" End="20.5 0 -5.5" Width="5" IsCuted="0"/>
</Plane>
</MicroDrawBan_XML>
`
const xml = `
<?xml version="1.0" encoding="UTF-8"?>
<Plate plateNumber="6189761091855" plateNickName="主卧_地柜A_横隔板01" width="512.32" depth="600" height="18" barCode="6189761091855" barCode1="">
    <Bandings>
        <Banding bandingBack="0.5" bandingRight="1.5" bandingFront="0.5" bandingLeft="0.5"/>
    </Bandings>
    <Holes>
        <Hole point="(500,479.32,18)" diameter="15" depth="14" direction="1" positionSide="1" drillDirection="(0,0,-1)"/>
        <Hole point="(308,479.32,18)" diameter="15" depth="14" direction="1" positionSide="1" drillDirection="(0,0,-1)"/>
        <Hole point="(116,479.32,18)" diameter="15" depth="14" direction="1" positionSide="1" drillDirection="(0,0,-1)"/>
        <Hole point="(500,0,9)" diameter="8" depth="33" direction="0" positionSide="1" drillDirection="(0,1,0)"/>
        <Hole point="(308,0,9)" diameter="8" depth="33" direction="0" positionSide="1" drillDirection="(0,1,0)"/>
        <Hole point="(116,0,9)" diameter="8" depth="33" direction="0" positionSide="1" drillDirection="(0,1,0)"/>
    </Holes>
    <Slottings>
        <Slotting positionSide="0" slottingStartX="20.5" slottingStartY="512.32" slottingStartZ="0.000" slottingEndX="20.5" slottingEndY="0" slottingEndZ="0.000" slottingWidth="5" slottingDepth="5.5"/>
        <Slotting positionSide="1" slottingStartX="20.5" slottingStartY="512.32" slottingStartZ="0.000" slottingEndX="20.5" slottingEndY="0" slottingEndZ="0.000" slottingWidth="5" slottingDepth="5.5"/>
    </Slottings>
    <YXJSlottings/>
    <H_Slottings/>
    <Points>
        <Point startPoint="(0,0,18)" endPoint="(0,512.32,18)" center="(0,0,0)" radius="" arcDirection="0" millingIndex="0" cutHeight="" isLagestEdge="1" cutPositionSide="正面"/>
        <Point startPoint="(0,512.32,18)" endPoint="(600,512.32,18)" center="(0,0,0)" radius="" arcDirection="0" millingIndex="0" cutHeight="" isLagestEdge="1" cutPositionSide="正面"/>
        <Point startPoint="(600,512.32,18)" endPoint="(600,0,18)" center="(0,0,0)" radius="" arcDirection="0" millingIndex="0" cutHeight="" isLagestEdge="1" cutPositionSide="正面"/>
        <Point startPoint="(600,0,18)" endPoint="(0,0,18)" center="(0,0,0)" radius="" arcDirection="0" millingIndex="0" cutHeight="" isLagestEdge="1" cutPositionSide="正面"/>
    </Points>
</Plate>
`
const xml2 = `
<?xml version="1.0" encoding="UTF-8"?>
<Root xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" Application="WoodMachine" ApplicationVersion="2.0">
    <Project Name="210727-128">
        <Panels>
            <Panel IsProduce="true" Thickness="18" ID="36130968" Name="主卧_柜A_左立板01" Material="18多层实木T01" Type="1" Length="1529.17" Width="600" MachiningPoint="1" Grain="W" BatchNo="210727-128" BatchIndex="" OrderNo="2021-07-27 16:26:12" Dealer="" ProdutionNo="" ProductionName="主卧" OrderDate="2021-07-27" Designer="用户158*2600" clerk="用户158*2600" EBL1="1.5*18厚封边无预铣" EBL2="1.5*18厚封边无预铣" EBW1="1.5*18厚封边无预铣" EBW2="1.5*18厚封边无预铣" HasHorizontalHole="有水平孔" PanelNo=" 36130968">
                <Machines>
                    <Machining ID="6350911" Type="2" IsGenCode="2" Face="5" X="891.61" Y="64" Diameter="5" Depth="5"/>
                    <Machining ID="6350912" Type="2" IsGenCode="2" Face="5" X="891.61" Y="96" Diameter="10" Depth="11"/>
                    <Machining ID="6350913" Type="2" IsGenCode="2" Face="5" X="891.61" Y="504" Diameter="10" Depth="11"/>
                    <Machining ID="6350914" Type="2" IsGenCode="2" Face="5" X="891.61" Y="536" Diameter="5" Depth="5"/>
                    <Machining ID="6350915" Type="2" IsGenCode="2" Face="5" X="891.61" Y="232" Diameter="10" Depth="11"/>
                    <Machining ID="6350916" Type="2" IsGenCode="2" Face="5" X="891.61" Y="368" Diameter="10" Depth="11"/>
                    <Machining ID="6350917" Type="2" IsGenCode="2" Face="5" X="407.31" Y="591" Diameter="10" Depth="11"/>
                    <Machining ID="6350918" Type="2" IsGenCode="2" Face="5" X="475.31" Y="591" Diameter="10" Depth="11"/>
                    <Machining ID="6350919" Type="4" IsGenCode="2" Face="5" X="887.76" Y="579.5" Depth="5.5" Width="5" ToolName="KC10" ToolOffset="中" EndX="0" EndY="579.5"/>
                    <Machining ID="6350920" Type="4" IsGenCode="2" Face="5" X="1529.17" Y="579.5" Depth="5.5" Width="5" ToolName="KC10" ToolOffset="中" EndX="895.46" EndY="579.5"/>
                </Machines>
                <EdgeGroup X1="0" Y1="0">
                    <Edge Face="1" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="2" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="3" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="4" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                </EdgeGroup>
            </Panel>
            <Panel IsProduce="true" Thickness="18" ID="36130969" Name="主卧_柜A_横隔板01" Material="18多层实木T01" Type="1" Length="1097.31" Width="600" MachiningPoint="1" Grain="W" BatchNo="210727-128" BatchIndex="" OrderNo="2021-07-27 16:26:12" Dealer="" ProdutionNo="" ProductionName="主卧" OrderDate="2021-07-27" Designer="用户158*2600" clerk="用户158*2600" EBL1="1.5*18厚封边无预铣" EBL2="1.5*18厚封边无预铣" EBW1="1.5*18厚封边无预铣" EBW2="0*18厚封边无预铣" HasHorizontalHole="有水平孔" PanelNo=" 36130969">
                <Machines>
                    <Machining ID="6350921" Type="3" IsGenCode="2" Face="5" X="1097.31" Y="0" Depth="18" ToolName="10MM-1" ToolOffset="中">
                        <Lines>
                            <Line Angle="0" EndX="1097.31" EndY="600" LineID="1"/>
                            <Line Angle="0" EndX="0" EndY="600" LineID="2"/>
                            <Line Angle="-90" EndX="600" EndY="0" LineID="3"/>
                            <Line Angle="0" EndX="1097.31" EndY="0" LineID="4"/>
                        </Lines>
                    </Machining>
                    <Machining ID="6350922" Type="2" IsGenCode="2" Face="5" X="1064.31" Y="96" Diameter="15" Depth="14.1"/>
                    <Machining ID="6350923" Type="2" IsGenCode="2" Face="5" X="1064.31" Y="504" Diameter="15" Depth="14.1"/>
                    <Machining ID="6350924" Type="2" IsGenCode="2" Face="5" X="1064.31" Y="232" Diameter="15" Depth="14.1"/>
                    <Machining ID="6350925" Type="2" IsGenCode="2" Face="5" X="1064.31" Y="368" Diameter="15" Depth="14.1"/>
                    <Machining ID="6350926" Type="1" IsGenCode="2" Face="3" X="1097.31" Y="64" Z="9" Diameter="5" Depth="25"/>
                    <Machining ID="6350927" Type="1" IsGenCode="2" Face="3" X="1097.31" Y="96" Z="9" Diameter="8" Depth="33"/>
                    <Machining ID="6350928" Type="1" IsGenCode="2" Face="3" X="1097.31" Y="504" Z="9" Diameter="8" Depth="33"/>
                    <Machining ID="6350929" Type="1" IsGenCode="2" Face="3" X="1097.31" Y="536" Z="9" Diameter="5" Depth="25"/>
                    <Machining ID="6350930" Type="1" IsGenCode="2" Face="3" X="1097.31" Y="232" Z="9" Diameter="8" Depth="33"/>
                    <Machining ID="6350931" Type="1" IsGenCode="2" Face="3" X="1097.31" Y="368" Z="9" Diameter="8" Depth="33"/>
                    <Machining ID="6350932" Type="4" IsGenCode="2" Face="6" X="1097.31" Y="579.5" Depth="5.5" Width="5" ToolName="KC10" ToolOffset="右" EndX="0.27" EndY="579.5"/>
                    <Machining ID="6350933" Type="4" IsGenCode="2" Face="5" X="1097.31" Y="579.5" Depth="5.5" Width="5" ToolName="KC10" ToolOffset="右" EndX="0.27" EndY="579.5"/>
                </Machines>
                <EdgeGroup X1="0" Y1="0">
                    <Edge Face="1" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="2" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="3" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="4" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                </EdgeGroup>
            </Panel>
            <Panel IsProduce="true" Thickness="5" ID="36130970" Name="主卧_柜A_背板02" Material="5装饰板T01" Type="1" Length="1102.31" Width="887.6" MachiningPoint="1" Grain="L" BatchNo="210727-128" BatchIndex="" OrderNo="2021-07-27 16:26:12" Dealer="" ProdutionNo="" ProductionName="主卧" OrderDate="2021-07-27" Designer="用户158*2600" clerk="用户158*2600" EBL1="0*5厚封边无预铣" EBL2="0*5厚封边无预铣" EBW1="0*5厚封边无预铣" EBW2="0*5厚封边无预铣" PanelNo=" 36130970">
                <EdgeGroup X1="0" Y1="0">
                    <Edge Face="1" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="2" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="3" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="4" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                </EdgeGroup>
            </Panel>
            <Panel IsProduce="true" Thickness="18" ID="36130971" Name="主卧_柜A_背板拉条02" Material="18多层实木T01" Type="1" Length="1097.31" Width="100" MachiningPoint="1" Grain="L" BatchNo="210727-128" BatchIndex="" OrderNo="2021-07-27 16:26:12" Dealer="" ProdutionNo="" ProductionName="主卧" OrderDate="2021-07-27" Designer="用户158*2600" clerk="用户158*2600" EBL1="1.5*18厚封边无预铣" EBL2="1.5*18厚封边无预铣" EBW1="0*18厚封边无预铣" EBW2="1.5*18厚封边无预铣" HasHorizontalHole="有水平孔" PanelNo=" 36130971">
                <Machines>
                    <Machining ID="6350934" Type="2" IsGenCode="2" Face="5" X="33" Y="16" Diameter="15" Depth="14.1"/>
                    <Machining ID="6350935" Type="2" IsGenCode="2" Face="5" X="33" Y="84" Diameter="15" Depth="14.1"/>
                    <Machining ID="6350936" Type="1" IsGenCode="2" Face="4" X="0" Y="16" Z="9" Diameter="8" Depth="33"/>
                    <Machining ID="6350937" Type="1" IsGenCode="2" Face="4" X="0" Y="84" Z="9" Diameter="8" Depth="33"/>
                </Machines>
                <EdgeGroup X1="0" Y1="0">
                    <Edge Face="1" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="2" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="3" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="4" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                </EdgeGroup>
            </Panel>
            <Panel IsProduce="true" Thickness="5" ID="36130972" Name="主卧_柜A_背板01" Material="5装饰板T01" Type="1" Length="1102.31" Width="633.56" MachiningPoint="1" Grain="L" BatchNo="210727-128" BatchIndex="" OrderNo="2021-07-27 16:26:12" Dealer="" ProdutionNo="" ProductionName="主卧" OrderDate="2021-07-27" Designer="用户158*2600" clerk="用户158*2600" EBL1="0*5厚封边无预铣" EBL2="0*5厚封边无预铣" EBW1="0*5厚封边无预铣" EBW2="0*5厚封边无预铣" PanelNo=" 36130972">
                <EdgeGroup X1="0" Y1="0">
                    <Edge Face="1" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="2" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="3" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="4" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                </EdgeGroup>
            </Panel>
            <Panel IsProduce="true" Thickness="18" ID="36130973" Name="主卧_柜A_背板拉条01" Material="18多层实木T01" Type="1" Length="628.56" Width="100" MachiningPoint="1" Grain="W" BatchNo="210727-128" BatchIndex="" OrderNo="2021-07-27 16:26:12" Dealer="" ProdutionNo="" ProductionName="主卧" OrderDate="2021-07-27" Designer="用户158*2600" clerk="用户158*2600" EBL1="1.5*18厚封边无预铣" EBL2="1.5*18厚封边无预铣" EBW1="1.5*18厚封边无预铣" EBW2="0*18厚封边无预铣" PanelNo=" 36130973">
                <EdgeGroup X1="0" Y1="0">
                    <Edge Face="1" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="2" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="3" Thickness="1.5" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                    <Edge Face="4" Thickness="0" Pre_Milling="0" X="0" Y="0" CentralAngle="0"/>
                </EdgeGroup>
            </Panel>
        </Panels>
    </Project>
</Root>
`
const xml3 = `
<KDTPanelFormat>
    <PANEL>
        <PanelLength>600</PanelLength>
        <PanelWidth>512.32</PanelWidth>
        <PanelThickness>18</PanelThickness>
        <PanelName>主卧_地柜A_横隔板01</PanelName>
        <Params>
            <Param Key="L" Value="600" Comment="板长"/>
            <Param Key="W" Value="512.32" Comment="板宽"/>
            <Param Key="T" Value="18" Comment="板厚"/>
        </Params>
    </PANEL>
    <CAD>
        <TypeNo>1</TypeNo>
        <TypeName>Vertical Hole</TypeName>
        <X1>500</X1>
        <Y1>479.32</Y1>
        <Depth>14</Depth>
        <Diameter>15</Diameter>
        <Enable>1</Enable>
        <HoleNo>1</HoleNo>
        <IntervalX>0.00</IntervalX>
        <IntervalY>0.00</IntervalY>
    </CAD>
    <CAD>
        <TypeNo>1</TypeNo>
        <TypeName>Vertical Hole</TypeName>
        <X1>308</X1>
        <Y1>479.32</Y1>
        <Depth>14</Depth>
        <Diameter>15</Diameter>
        <Enable>1</Enable>
        <HoleNo>1</HoleNo>
        <IntervalX>0.00</IntervalX>
        <IntervalY>0.00</IntervalY>
    </CAD>
    <CAD>
        <TypeNo>1</TypeNo>
        <TypeName>Vertical Hole</TypeName>
        <X1>116</X1>
        <Y1>479.32</Y1>
        <Depth>14</Depth>
        <Diameter>15</Diameter>
        <Enable>1</Enable>
        <HoleNo>1</HoleNo>
        <IntervalX>0.00</IntervalX>
        <IntervalY>0.00</IntervalY>
    </CAD>
    <CAD>
        <TypeNo>2</TypeNo>
        <TypeName>Horizontal Hole</TypeName>
        <X1>500</X1>
        <Y1>512.32</Y1>
        <Z1>9</Z1>
        <Quadrant>3</Quadrant>
        <Depth>33</Depth>
        <Diameter>8</Diameter>
        <Enable>1</Enable>
        <HoleNo>1</HoleNo>
        <IntervalX>0.00</IntervalX>
        <IntervalY>0.00</IntervalY>
        <IntervalZ>0.00</IntervalZ>
    </CAD>
    <CAD>
        <TypeNo>2</TypeNo>
        <TypeName>Horizontal Hole</TypeName>
        <X1>308</X1>
        <Y1>512.32</Y1>
        <Z1>9</Z1>
        <Quadrant>3</Quadrant>
        <Depth>33</Depth>
        <Diameter>8</Diameter>
        <Enable>1</Enable>
        <HoleNo>1</HoleNo>
        <IntervalX>0.00</IntervalX>
        <IntervalY>0.00</IntervalY>
        <IntervalZ>0.00</IntervalZ>
    </CAD>
    <CAD>
        <TypeNo>2</TypeNo>
        <TypeName>Horizontal Hole</TypeName>
        <X1>116</X1>
        <Y1>512.32</Y1>
        <Z1>9</Z1>
        <Quadrant>3</Quadrant>
        <Depth>33</Depth>
        <Diameter>8</Diameter>
        <Enable>1</Enable>
        <HoleNo>1</HoleNo>
        <IntervalX>0.00</IntervalX>
        <IntervalY>0.00</IntervalY>
        <IntervalZ>0.00</IntervalZ>
    </CAD>
    <CAD>
        <TypeNo>13</TypeNo>
        <TypeName>Line</TypeName>
        <BeginX>20.5</BeginX>
        <BeginY>512.32</BeginY>
        <EndX>20.5</EndX>
        <EndY>0</EndY>
        <Correction>0</Correction>
        <Width>5</Width>
        <Depth>5.5</Depth>
        <Enable>1</Enable>
    </CAD>
    <CAD>
        <TypeNo>3</TypeNo>
        <TypeName>Line</TypeName>
        <BeginX>20.5</BeginX>
        <BeginY>512.32</BeginY>
        <EndX>20.5</EndX>
        <EndY>0</EndY>
        <Correction>0</Correction>
        <Width>5</Width>
        <Depth>5.5</Depth>
        <Enable>1</Enable>
    </CAD>
</KDTPanelFormat>
`
const mpr = `
[H\\Left:1.0;Bottom:1.0;Right:1.0;Top:1.5
  VERSION="4.0 Alpha"
  VIEW="NOMIRROR"
  OP="1"
  FM="1"
  FW="800"
  HP="1"
  UP="0"
  GX="1"
  DW="0"
  ModusMirror="1"
  
  <100 \\WerkStck\\
  LA="1039.96"
  BR="500"
  DI="18"
  FNX="0"
  FNY="0"
  RNX="0"
  RNY="0"
  RNZ="0"
  AX="0"
  AY="0"
  
  <102 \\V_DRILLING\\
  XA="9.0"
  YA="84.0"
  BM="LS"
  TI="12.0"
  DU="10.0"
  AN="1"
  MI="0"
  S_="2"
  AB="32"
  WI="0"
  HP="0"
  SP="0"
  YVE="0"
  WW="60,61,62,88,90,91,92,150"
  ASG="2"
  KAT="Bohren vertikal"
  MNM="Vertical drilling"
  MX="0"
  MY="0"
  MZ="0"
  MXF="1"
  MYF="1"
  MZF="1"
  
  <102 \\V_DRILLING\\
  XA="9.0"
  YA="436.0"
  BM="LS"
  TI="12.0"
  DU="10.0"
  AN="1"
  MI="0"
  S_="2"
  AB="32"
  WI="0"
  HP="0"
  SP="0"
  YVE="0"
  WW="60,61,62,88,90,91,92,150"
  ASG="2"
  KAT="Bohren vertikal"
  MNM="Vertical drilling"
  MX="0"
  MY="0"
  MZ="0"
  MXF="1"
  MYF="1"
  MZF="1"
  
  <102 \\V_DRILLING\\
  XA="1030.96"
  YA="84.0"
  BM="LS"
  TI="12.0"
  DU="10.0"
  AN="1"
  MI="0"
  S_="2"
  AB="32"
  WI="0"
  HP="0"
  SP="0"
  YVE="0"
  WW="60,61,62,88,90,91,92,150"
  ASG="2"
  KAT="Bohren vertikal"
  MNM="Vertical drilling"
  MX="0"
  MY="0"
  MZ="0"
  MXF="1"
  MYF="1"
  MZF="1"
  
  <102 \\V_DRILLING\\
  XA="1030.96"
  YA="436.0"
  BM="LS"
  TI="12.0"
  DU="10.0"
  AN="1"
  MI="0"
  S_="2"
  AB="32"
  WI="0"
  HP="0"
  SP="0"
  YVE="0"
  WW="60,61,62,88,90,91,92,150"
  ASG="2"
  KAT="Bohren vertikal"
  MNM="Vertical drilling"
  MX="0"
  MY="0"
  MZ="0"
  MXF="1"
  MYF="1"
  MZF="1"
  
  <101 \\Kommentar\\
  KM="主卧_柜A_顶板01"
  !
`
const dxf = `
0
SECTION
  2
HEADER
  9
$ACADVER
  1
AC1009
  9
$DWGCODEPAGE
  3
ANSI_936
  9
$INSBASE
 10
0.0
 20
0.0
 30
0.0
  9
$EXTMIN
 10
1e+20
 20
1e+20
 30
1e+20
  9
$EXTMAX
 10
-1e+20
 20
-1e+20
 30
-1e+20
  9
$LIMMIN
 10
0.0
 20
0.0
  9
$LIMMAX
 10
2440.0
 20
1220.0
  9
$ORTHOMODE
 70
0
  9
$REGENMODE
 70
1
  9
$FILLMODE
 70
1
  9
$DRAGMODE
 70
2
  9
$QTEXTMODE
 70
0
  9
$MIRRTEXT
 70
1
  9
$OSMODE
 70
20583
  9
$LTSCALE
 40
1.0
  9
$ATTMODE
 70
1
  9
$TEXTSIZE
 40
2.5
  9
$TRACEWID
 40
1.0
  9
$TEXTSTYLE
  7
Standard
  9
$CLAYER
  8
0
  9
$CELTYPE
  6
ByLayer
  9
$CECOLOR
 62
256
  9
$DIMSCALE
 40
1.0
  9
$DIMASZ
 40
2.5
  9
$DIMEXO
 40
0.625
  9
$DIMDLI
 40
3.75
  9
$DIMRND
 40
0.0
  9
$DIMDLE
 40
0.0
  9
$DIMEXE
 40
1.25
  9
$DIMTP
 40
0.0
  9
$DIMTM
 40
0.0
  9
$DIMTXT
 40
2.5
  9
$DIMCEN
 40
2.5
  9
$DIMTSZ
 40
0.0
  9
$DIMTOL
 70
0
  9
$DIMLIM
 70
0
  9
$DIMTIH
 70
0
  9
$DIMTOH
 70
0
  9
$DIMSE1
 70
0
  9
$DIMSE2
 70
0
  9
$DIMTAD
 70
1
  9
$DIMZIN
 70
8
  9
$DIMBLK
  1

  9
$DIMASO
 70
1
  9
$DIMSHO
 70
1
  9
$DIMPOST
  1

  9
$DIMAPOST
  1

  9
$DIMALT
 70
0
  9
$DIMALTD
 70
3
  9
$DIMALTF
 40
0.03937007874
  9
$DIMLFAC
 40
1.0
  9
$DIMTOFL
 70
1
  9
$DIMTVP
 40
0.0
  9
$DIMTIX
 70
0
  9
$DIMSOXD
 70
0
  9
$DIMSAH
 70
0
  9
$DIMBLK1
  1

  9
$DIMBLK2
  1

  9
$DIMSTYLE
  2
ISO-25
  9
$DIMCLRD
 70
0
  9
$DIMCLRE
 70
0
  9
$DIMCLRT
 70
0
  9
$DIMTFAC
 40
1.0
  9
$DIMGAP
 40
0.625
  9
$COORDS
 70
1
  9
$ATTDIA
 70
0
  9
$ATTREQ
 70
1
  9
$HANDLING
 70
1
  9
$LUNITS
 70
2
  9
$LUPREC
 70
4
  9
$SKETCHINC
 40
1.0
  9
$FILLETRAD
 40
10.0
  9
$AUNITS
 70
0
  9
$AUPREC
 70
2
  9
$MENU
  1
.
  9
$ELEVATION
 40
0.0
  9
$PELEVATION
 40
0.0
  9
$THICKNESS
 40
0.0
  9
$LIMCHECK
 70
0
  9
$CHAMFERA
 40
0.0
  9
$CHAMFERB
 40
0.0
  9
$SKPOLY
 70
0
  9
$TDCREATE
 40
2459990.829050926
  9
$TDUPDATE
 40
2459990.829050926
  9
$TDINDWG
 40
0.0
  9
$TDUSRTIMER
 40
0.0
  9
$USRTIMER
 70
1
  9
$ANGBASE
 50
0.0
  9
$ANGDIR
 70
0
  9
$PDMODE
 70
0
  9
$PDSIZE
 40
0.0
  9
$PLINEWID
 40
0.0
  9
$SPLFRAME
 70
0
  9
$SPLINETYPE
 70
6
  9
$SPLINESEGS
 70
8
  9
$HANDSEED
  5
40
  9
$SURFTAB1
 70
6
  9
$SURFTAB2
 70
6
  9
$SURFTYPE
 70
6
  9
$SURFU
 70
6
  9
$SURFV
 70
6
  9
$UCSNAME
  2

  9
$UCSORG
 10
0.0
 20
0.0
 30
0.0
  9
$UCSXDIR
 10
1.0
 20
0.0
 30
0.0
  9
$UCSYDIR
 10
0.0
 20
1.0
 30
0.0
  9
$PUCSNAME
  2

  9
$PUCSORG
 10
0.0
 20
0.0
 30
0.0
  9
$PUCSXDIR
 10
1.0
 20
0.0
 30
0.0
  9
$PUCSYDIR
 10
0.0
 20
1.0
 30
0.0
  9
$USERI1
 70
0
  9
$USERI2
 70
0
  9
$USERI3
 70
0
  9
$USERI4
 70
0
  9
$USERI5
 70
0
  9
$USERR1
 40
0.0
  9
$USERR2
 40
0.0
  9
$USERR3
 40
0.0
  9
$USERR4
 40
0.0
  9
$USERR5
 40
0.0
  9
$WORLDVIEW
 70
1
  9
$SHADEDGE
 70
3
  9
$SHADEDIF
 70
70
  9
$TILEMODE
 70
1
  9
$MAXACTVP
 70
64
  9
$PLIMCHECK
 70
0
  9
$PEXTMIN
 10
1e+20
 20
1e+20
 30
1e+20
  9
$PEXTMAX
 10
-1e+20
 20
-1e+20
 30
-1e+20
  9
$PLIMMIN
 10
0.0
 20
0.0
  9
$PLIMMAX
 10
420.0
 20
297.0
  9
$UNITMODE
 70
0
  9
$VISRETAIN
 70
1
  9
$PLINEGEN
 70
0
  9
$PSLTSCALE
 70
1
  0
ENDSEC
  0
SECTION
  2
TABLES
  0
TABLE
  2
VPORT
 70
1
  0
VPORT
  5
23
  2
*Active
 70
0
 10
0.0
 20
0.0
 11
1.0
 21
1.0
 12
0.0
 22
0.0
 13
0.0
 23
0.0
 14
0.5
 24
0.5
 15
0.5
 25
0.5
 16
0.0
 26
0.0
 36
1.0
 17
0.0
 27
0.0
 37
0.0
 40
1000.0
 41
1.34
 42
50.0
 43
0.0
 44
0.0
 50
0.0
 51
0.0
 71
0
 72
1000
 73
1
 74
3
 75
0
 76
0
 77
0
 78
0
  0
ENDTAB
  0
TABLE
  2
LTYPE
 70
3
  0
LTYPE
  5
24
  2
ByBlock
 70
0
  3

 72
65
 73
0
 40
0.0
  0
LTYPE
  5
25
  2
ByLayer
 70
0
  3

 72
65
 73
0
 40
0.0
  0
LTYPE
  5
26
  2
Continuous
 70
0
  3

 72
65
 73
0
 40
0.0
  0
ENDTAB
  0
TABLE
  2
LAYER
 70
2
  0
LAYER
  5
27
  2
0
 70
0
 62
7
  6
Continuous
  0
LAYER
  5
28
  2
Defpoints
 70
0
 62
7
  6
Continuous
  0
ENDTAB
  0
TABLE
  2
STYLE
 70
1
  0
STYLE
  5
29
  2
Standard
 70
0
 40
0.0
 41
1.0
 50
0.0
 71
0
 42
2.5
  3
txt
  4
gbcbig.shx
  0
ENDTAB
  0
TABLE
  2
VIEW
 70
0
  0
ENDTAB
  0
TABLE
  2
UCS
 70
0
  0
ENDTAB
  0
TABLE
  2
APPID
 70
3
  0
APPID
  5
2A
  2
ACAD
 70
0
  0
APPID
  5
3E
  2
HATCHBACKGROUNDCOLOR
 70
0
  0
APPID
  5
3F
  2
EZDXF
 70
0
  0
ENDTAB
  0
TABLE
  2
DIMSTYLE
 70
1
  0
DIMSTYLE
105
2B
  2
Standard
 70
0
  3

  4

  5

  6

  7

 40
1.0
 41
2.5
 42
0.625
 43
3.75
 44
1.25
 45
0.0
 46
0.0
 47
0.0
 48
0.0
140
2.5
141
2.5
142
0.0
143
0.03937007874
144
1.0
145
0.0
146
1.0
147
0.625
 71
0
 72
0
 73
0
 74
0
 75
0
 76
0
 77
1
 78
8
170
0
171
3
172
1
173
0
174
0
175
0
176
0
177
0
178
0
  0
ENDTAB
  0
ENDSEC
  0
SECTION
  2
BLOCKS
  0
BLOCK
  5
18
  8
0
  2
$Model_Space
 70
0
 10
0.0
 20
0.0
 30
0.0
  3
$Model_Space
  1

1001
EZDXF
1000
CREATED_BY_EZDXF
1000
0.18.1 @ 2023-02-14T11:53:50.867430+00:00
1000
WRITTEN_BY_EZDXF
1000
0.18.1 @ 2023-02-14T11:53:50.868370+00:00
  0
ENDBLK
  5
19
  8
0
  0
BLOCK
  5
1C
  8
0
  2
$Paper_Space
 70
0
 10
0.0
 20
0.0
 30
0.0
  3
$Paper_Space
  1

  0
ENDBLK
  5
1D
  8
0
  0
ENDSEC
  0
SECTION
  2
ENTITIES
  0
TEXT
  5
2D
  8
parts label
 10
1.0
 20
5.0
 30
0.0
 40
4.0
  1
(1)顶板01,1039.96x500
 11
1.0
 21
5.0
 31
0.0
  0
TEXT
  5
2E
  8
parts label
 10
-30.0
 20
250.0
 30
0.0
 40
8.0
  1
FB:(1,1,1,1.5)
 11
-30.0
 21
250.0
 31
0.0
  0
POLYLINE
  5
2F
  8
PL18.0
  6
Continuous
 66
1
 10
0.0
 20
0.0
 30
0.0
 70
1
 39
-18.0
  0
VERTEX
  5
31
  8
PL18.0
  6
Continuous
 10
0.0
 20
0.0
 30
0.0
 70
0
  0
VERTEX
  5
32
  8
PL18.0
  6
Continuous
 10
1039.96
 20
0.0
 30
0.0
 70
0
  0
VERTEX
  5
33
  8
PL18.0
  6
Continuous
 10
1039.96
 20
500.0
 30
0.0
 70
0
  0
VERTEX
  5
34
  8
PL18.0
  6
Continuous
 10
0.0
 20
500.0
 30
0.0
 70
0
  0
VERTEX
  5
35
  8
PL18.0
  6
Continuous
 10
0.0
 20
0.0
 30
0.0
 70
0
  0
SEQEND
  5
30
  8
PL18.0
  0
TEXT
  5
36
  8
parts label
 10
10.0
 20
89.0
 30
0.0
 40
6.0
  1
(10.0,9.0,84.0)
 11
10.0
 21
89.0
 31
0.0
  0
CIRCLE
  5
37
  8
VD_Z12.0_T0_D5.0
 10
9.0
 20
84.0
 30
0.0
 40
5.0
 39
-12.0
  0
TEXT
  5
38
  8
parts label
 10
10.0
 20
441.0
 30
0.0
 40
6.0
  1
(10.0,9.0,436.0)
 11
10.0
 21
441.0
 31
0.0
  0
CIRCLE
  5
39
  8
VD_Z12.0_T0_D5.0
 10
9.0
 20
436.0
 30
0.0
 40
5.0
 39
-12.0
  0
TEXT
  5
3A
  8
parts label
 10
1031.96
 20
89.0
 30
0.0
 40
6.0
  1
(10.0,1030.96,84.0)
 11
1031.96
 21
89.0
 31
0.0
  0
CIRCLE
  5
3B
  8
VD_Z12.0_T0_D5.0
 10
1030.96
 20
84.0
 30
0.0
 40
5.0
 39
-12.0
  0
TEXT
  5
3C
  8
parts label
 10
1031.96
 20
441.0
 30
0.0
 40
6.0
  1
(10.0,1030.96,436.0)
 11
1031.96
 21
441.0
 31
0.0
  0
CIRCLE
  5
3D
  8
VD_Z12.0_T0_D5.0
 10
1030.96
 20
436.0
 30
0.0
 40
5.0
 39
-12.0
  0
ENDSEC
  0
EOF
`

const xinhongtian = `
<MicroDrawBan_XML Version="3.0" Time="2024/06/04" Source="云排版软件" SourceType="">
<Plane Material="颗粒板Default" Code="" Name="颗粒板Default" Width="1220.00" Hight="2440.00" Thickness="18.00" Grain=" " EdgeFBLR="0,0,0,0" >
  <Outline>
    <Point Value="0 0 0"/>
    <Point Value="1220.00 0 0"/>
    <Point Value="1220.00 2440.00 0"/>
    <Point Value="0 2440.00 0"/>
    <Point Value="0 0 0"/>
  </Outline>
  <HoleV Name="" Face="B" Start="36.00 1364.80 -18.00" End="36.00 1364.80 -4.50" Diameter="15.00" IsCuted="0"/>
  <HoleV Name="" Face="B" Start="322.00 1364.80 -18.00" End="322.00 1364.80 -4.50" Diameter="15.00" IsCuted="0"/>
  <HoleV Name="" Face="B" Start="36.00 1662.80 -18.00" End="36.00 1662.80 -4.50" Diameter="15.00" IsCuted="0"/>
  <HoleV Name="" Face="B" Start="322.00 1662.80 -18.00" End="322.00 1662.80 -4.50" Diameter="15.00" IsCuted="0"/>
  <HoleV Name="" Face="B" Start="68.00 2277.00 -18.00" End="68.00 2277.00 -7.00" Diameter="10.00" IsCuted="0"/>
  <HoleV Name="" Face="B" Start="290.00 2277.00 -18.00" End="290.00 2277.00 -7.00" Diameter="10.00" IsCuted="0"/>
  <SlotL Name="" Face="B" Start="24.50 973.60 -12.00" End="24.50 1146.60 -12.00" Width="6.00" IsCuted="0"/>
  <SlotL Name="" Face="B" Start="24.50 1152.70 -12.00" End="24.50 1325.70 -12.00" Width="6.00" IsCuted="0"/>
  <SlotL Name="" Face="B" Start="24.50 2065.90 -12.00" End="24.50 1701.90 -12.00" Width="6.00" IsCuted="0"/>
  <SlotL Name="" Face="B" Start="24.50 2273.15 -12.00" End="24.50 2072.00 -12.00" Width="6.00" IsCuted="0"/>
  <SlotL Name="" Face="B" Start="24.50 2436.00 -12.00" End="24.50 2280.85 -12.00" Width="6.00" IsCuted="0"/>
</Plane>
</MicroDrawBan_XML>
`

const pinmai = `
<MicroDrawBan_XML Version="3.0" Time="2024/06/04" Source="云排版软件" SourceType="">
  <Plane Material="颗粒板Default" Code="" Name="颗粒板Default" Width="1220.00" Hight="2440.00" Thickness="18.00" Grain=" " EdgeFBLR="0,0,0,0" >
    <Outline>
      <Point Value="0 0 0"/>
      <Point Value="1220.00 0 0"/>
      <Point Value="1220.00 2440.00 0"/>
      <Point Value="0 2440.00 0"/>
      <Point Value="0 0 0"/>
    </Outline>
    <HoleV Name="" Face="A" Start="36.00 1006.60 0.00" End="36.00 1006.60 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 1006.60 0.00" End="322.00 1006.60 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 1113.60 0.00" End="36.00 1113.60 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 1113.60 0.00" End="322.00 1113.60 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 1185.70 0.00" End="36.00 1185.70 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 1185.70 0.00" End="322.00 1185.70 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="68.00 1292.70 0.00" End="68.00 1292.70 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="290.00 1292.70 0.00" End="290.00 1292.70 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 1490.80 0.00" End="36.00 1490.80 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 1490.80 0.00" End="322.00 1490.80 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 2032.90 0.00" End="36.00 2032.90 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 2032.90 0.00" End="322.00 2032.90 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 1734.90 0.00" End="36.00 1734.90 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 1734.90 0.00" End="322.00 1734.90 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 1906.90 0.00" End="36.00 1906.90 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 1906.90 0.00" End="322.00 1906.90 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 2403.00 0.00" End="36.00 2403.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 2403.00 0.00" End="322.00 2403.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 2105.00 0.00" End="36.00 2105.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 2105.00 0.00" End="322.00 2105.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="36.00 2277.00 0.00" End="36.00 2277.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="322.00 2277.00 0.00" End="322.00 2277.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="36.00 1364.80 -18.00" End="36.00 1364.80 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="322.00 1364.80 -18.00" End="322.00 1364.80 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="36.00 1662.80 -18.00" End="36.00 1662.80 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="322.00 1662.80 -18.00" End="322.00 1662.80 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="68.00 2277.00 -18.00" End="68.00 2277.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="290.00 2277.00 -18.00" End="290.00 2277.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 973.60 -6.00" End="24.50 1146.60 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 1152.70 -6.00" End="24.50 1325.70 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 1494.65 -6.00" End="24.50 1695.80 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 1331.80 -6.00" End="24.50 1486.95 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 1903.05 -6.00" End="24.50 1701.90 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 2065.90 -6.00" End="24.50 1910.75 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 2273.15 -6.00" End="24.50 2072.00 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="24.50 2436.00 -6.00" End="24.50 2280.85 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="24.50 973.60 -12.00" End="24.50 1146.60 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="24.50 1152.70 -12.00" End="24.50 1325.70 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="24.50 2065.90 -12.00" End="24.50 1701.90 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="24.50 2273.15 -12.00" End="24.50 2072.00 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="24.50 2436.00 -12.00" End="24.50 2280.85 -12.00" Width="6.00" IsCuted="0"/>
  </Plane>
</MicroDrawBan_XML>
`

const ruinuo = `
<MicroDrawBan_XML Version="3.0" Time="2024/06/04" Source="云排版软件" SourceType="">
  <Plane Material="颗粒板Default" Code="" Name="颗粒板Default" Width="1220.00" Hight="2440.00" Thickness="18.00" Grain=" " EdgeFBLR="0,0,0,0" >
    <Outline>
      <Point Value="0 0 0"/>
      <Point Value="1220.00 0 0"/>
      <Point Value="1220.00 2440.00 0"/>
      <Point Value="0 2440.00 0"/>
      <Point Value="0 0 0"/>
    </Outline>
    <HoleV Name="" Face="A" Start="1184.00 1433.40 0.00" End="1184.00 1433.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 1433.40 0.00" End="898.00 1433.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 1326.40 0.00" End="1184.00 1326.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 1326.40 0.00" End="898.00 1326.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 1254.30 0.00" End="1184.00 1254.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 1254.30 0.00" End="898.00 1254.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1152.00 1147.30 0.00" End="1152.00 1147.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="930.00 1147.30 0.00" End="930.00 1147.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 949.20 0.00" End="1184.00 949.20 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 949.20 0.00" End="898.00 949.20 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 407.10 0.00" End="1184.00 407.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 407.10 0.00" End="898.00 407.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 705.10 0.00" End="1184.00 705.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 705.10 0.00" End="898.00 705.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 533.10 0.00" End="1184.00 533.10 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 533.10 0.00" End="898.00 533.10 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 37.00 0.00" End="1184.00 37.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 37.00 0.00" End="898.00 37.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 335.00 0.00" End="1184.00 335.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 335.00 0.00" End="898.00 335.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 163.00 0.00" End="1184.00 163.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 163.00 0.00" End="898.00 163.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1184.00 1075.20 -18.00" End="1184.00 1075.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="898.00 1075.20 -18.00" End="898.00 1075.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1184.00 777.20 -18.00" End="1184.00 777.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="898.00 777.20 -18.00" End="898.00 777.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1152.00 163.00 -18.00" End="1152.00 163.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="930.00 163.00 -18.00" End="930.00 163.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 1466.40 -6.00" End="1195.50 1293.40 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 1287.30 -6.00" End="1195.50 1114.30 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 945.35 -6.00" End="1195.50 744.20 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 1108.20 -6.00" End="1195.50 953.05 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 536.95 -6.00" End="1195.50 738.10 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 374.10 -6.00" End="1195.50 529.25 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 166.85 -6.00" End="1195.50 368.00 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 4.00 -6.00" End="1195.50 159.15 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 1466.40 -12.00" End="1195.50 1293.40 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 1287.30 -12.00" End="1195.50 1114.30 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 374.10 -12.00" End="1195.50 738.10 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 166.85 -12.00" End="1195.50 368.00 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 4.00 -12.00" End="1195.50 159.15 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1220.00 2438.00 -18.00" End="0.00 2438.00 -18.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="2.00 2440.00 -18.00" End="2.00 0.00 -18.00" Width="6.00" IsCuted="0"/>
  </Plane>
</MicroDrawBan_XML>
`

const kaihong = `
<MicroDrawBan_XML Version="3.0" Time="2024/06/04" Source="云排版软件" SourceType="">
  <Plane Material="颗粒板Default" Code="" Name="颗粒板Default" Width="1220.00" Hight="2440.00" Thickness="18.00" Grain=" " EdgeFBLR="0,0,0,0" >
    <Outline>
      <Point Value="0 0 0"/>
      <Point Value="1220.00 0 0"/>
      <Point Value="1220.00 2440.00 0"/>
      <Point Value="0 2440.00 0"/>
      <Point Value="0 0 0"/>
    </Outline>
    <HoleV Name="" Face="A" Start="1184.00 1433.40 0.00" End="1184.00 1433.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 1433.40 0.00" End="898.00 1433.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 1326.40 0.00" End="1184.00 1326.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 1326.40 0.00" End="898.00 1326.40 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 1254.30 0.00" End="1184.00 1254.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 1254.30 0.00" End="898.00 1254.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1152.00 1147.30 0.00" End="1152.00 1147.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="930.00 1147.30 0.00" End="930.00 1147.30 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 949.20 0.00" End="1184.00 949.20 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 949.20 0.00" End="898.00 949.20 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 407.10 0.00" End="1184.00 407.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 407.10 0.00" End="898.00 407.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 705.10 0.00" End="1184.00 705.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 705.10 0.00" End="898.00 705.10 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 533.10 0.00" End="1184.00 533.10 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 533.10 0.00" End="898.00 533.10 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 37.00 0.00" End="1184.00 37.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 37.00 0.00" End="898.00 37.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 335.00 0.00" End="1184.00 335.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 335.00 0.00" End="898.00 335.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1184.00 163.00 0.00" End="1184.00 163.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="898.00 163.00 0.00" End="898.00 163.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1184.00 1075.20 -18.00" End="1184.00 1075.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="898.00 1075.20 -18.00" End="898.00 1075.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1184.00 777.20 -18.00" End="1184.00 777.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="898.00 777.20 -18.00" End="898.00 777.20 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1152.00 163.00 -18.00" End="1152.00 163.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="930.00 163.00 -18.00" End="930.00 163.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 1466.40 -6.00" End="1195.50 1293.40 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 1287.30 -6.00" End="1195.50 1114.30 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 945.35 -6.00" End="1195.50 744.20 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 1108.20 -6.00" End="1195.50 953.05 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 536.95 -6.00" End="1195.50 738.10 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 374.10 -6.00" End="1195.50 529.25 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 166.85 -6.00" End="1195.50 368.00 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1195.50 4.00 -6.00" End="1195.50 159.15 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 1466.40 -12.00" End="1195.50 1293.40 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 1287.30 -12.00" End="1195.50 1114.30 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 374.10 -12.00" End="1195.50 738.10 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 166.85 -12.00" End="1195.50 368.00 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1195.50 4.00 -12.00" End="1195.50 159.15 -12.00" Width="6.00" IsCuted="0"/>
  </Plane>
</MicroDrawBan_XML>
`

const jidong = `
<?xml version="1.0" encoding="utf-8"?>
<patchs task="">
  <patch patchid="">
    <plates>
      <plate orderid="" platenickname="多层实木T01" materialname="多层实木T01" mapstype="" numbercode="2Z" numbercode1="2FK" platenumber="0" frontholegroup="" bigplatenum="" statuscode="0" customerphone="" customercontacts="" customercity="" customeraddress="" customerprovince="" customercompany="" customercode="" customername="" texturename="" materialcolor="" plateflag="" platecalssid="" cabinetname="" cabinetid="" targetdeliverydate="" ordermakedate="" dealerahone="" dealeraddress="" backholegroup="" leftholegroup="" rightholegroup="" platemassnum="" bandingrightde="0" bandingleftde="0" bandingbackde="0" bandingfrontde="0" bandingfront="0" width="2440.0" depth="1220.0" height="18.0">
        <bandings>
          <banding bandingfront="0" bandingback="0" bandingleft="0" bandingright="0" />
        </bandings>
        <holes>
          <hole holetag="" point="(1113.60,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1113.60,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1006.60,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1006.60,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1292.70,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1292.70,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1185.70,-68.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1185.70,-290.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1536.80,-36.00,18.00)" diameter="10.0" depth="11.00" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1536.80,-322.00,18.00)" diameter="10.0" depth="11.00" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1734.90,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1734.90,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2032.90,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2032.90,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1860.90,-36.00,18.00)" diameter="10.0" depth="11.00" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1860.90,-322.00,18.00)" diameter="10.0" depth="11.00" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2105.00,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2105.00,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2403.00,-36.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2403.00,-322.00,18.00)" diameter="15.0" depth="13.50" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2231.00,-36.00,18.00)" diameter="10.0" depth="11.00" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(2231.00,-322.00,18.00)" diameter="10.0" depth="11.00" direction="1" positionside="1" drilldirection="(0,0,-1)" />
          <hole holetag="" point="(1662.80,-36.00,0.00)" diameter="15.0" depth="13.50" direction="1" positionside="0" drilldirection="(0,0,1)" />
          <hole holetag="" point="(1662.80,-322.00,0.00)" diameter="15.0" depth="13.50" direction="1" positionside="0" drilldirection="(0,0,1)" />
          <hole holetag="" point="(1364.80,-36.00,0.00)" diameter="15.0" depth="13.50" direction="1" positionside="0" drilldirection="(0,0,1)" />
          <hole holetag="" point="(1364.80,-322.00,0.00)" diameter="15.0" depth="13.50" direction="1" positionside="0" drilldirection="(0,0,1)" />
          <hole holetag="" point="(2231.00,-68.00,0.00)" diameter="10.0" depth="11.00" direction="1" positionside="0" drilldirection="(0,0,1)" />
          <hole holetag="" point="(2231.00,-290.00,0.00)" diameter="10.0" depth="11.00" direction="1" positionside="0" drilldirection="(0,0,1)" />
        </holes>
        <slottings>
          <slotting positionside="1" slottingstartx="1146.60" slottingstarty="-24.50" slottingstartz="0" slottingendx="973.60" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="1325.70" slottingstarty="-24.50" slottingstartz="0" slottingendx="1152.70" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="1532.95" slottingstarty="-24.50" slottingstartz="0" slottingendx="1331.80" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="1695.80" slottingstarty="-24.50" slottingstartz="0" slottingendx="1540.65" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="1864.75" slottingstarty="-24.50" slottingstartz="0" slottingendx="2065.90" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="1701.90" slottingstarty="-24.50" slottingstartz="0" slottingendx="1857.05" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="2234.85" slottingstarty="-24.50" slottingstartz="0" slottingendx="2436.00" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="1" slottingstartx="2072.00" slottingstarty="-24.50" slottingstartz="0" slottingendx="2227.15" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="0" slottingstartx="1146.60" slottingstarty="-24.50" slottingstartz="0" slottingendx="973.60" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="0" slottingstartx="1325.70" slottingstarty="-24.50" slottingstartz="0" slottingendx="1152.70" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="0" slottingstartx="1701.90" slottingstarty="-24.50" slottingstartz="0" slottingendx="2065.90" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="0" slottingstartx="2234.85" slottingstarty="-24.50" slottingstartz="0" slottingendx="2436.00" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
          <slotting positionside="0" slottingstartx="2072.00" slottingstarty="-24.50" slottingstartz="0" slottingendx="2227.15" slottingendy="-24.50" slottingendz="0" slottingwidth="6.00" slottingdepth="6.0" />
        </slottings>
      </plate>
    </plates>
  </patch>
</patchs>
`

const nanxingfeida = `
<MicroDrawBan_XML Version="3.0" Time="2024/06/04" Source="云排版软件" SourceType="">
  <Plane Material="颗粒板Default" Code="" Name="颗粒板Default" Width="2440.00" Hight="1220.00" Thickness="18.00" Grain=" " EdgeFBLR="0,0,0,0" >
    <Outline>
      <Point Value="0 0 0"/>
      <Point Value="2440.00 0 0"/>
      <Point Value="2440.00 1220.00 0"/>
      <Point Value="0 1220.00 0"/>
      <Point Value="0 0 0"/>
    </Outline>
    <HoleV Name="" Face="A" Start="1433.40 36.00 0.00" End="1433.40 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1433.40 322.00 0.00" End="1433.40 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1326.40 36.00 0.00" End="1326.40 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1326.40 322.00 0.00" End="1326.40 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1254.30 36.00 0.00" End="1254.30 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1254.30 322.00 0.00" End="1254.30 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1147.30 68.00 0.00" End="1147.30 68.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="1147.30 290.00 0.00" End="1147.30 290.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="949.20 36.00 0.00" End="949.20 36.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="949.20 322.00 0.00" End="949.20 322.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="407.10 36.00 0.00" End="407.10 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="407.10 322.00 0.00" End="407.10 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="705.10 36.00 0.00" End="705.10 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="705.10 322.00 0.00" End="705.10 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="533.10 36.00 0.00" End="533.10 36.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="533.10 322.00 0.00" End="533.10 322.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="37.00 36.00 0.00" End="37.00 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="37.00 322.00 0.00" End="37.00 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="335.00 36.00 0.00" End="335.00 36.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="335.00 322.00 0.00" End="335.00 322.00 -13.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="163.00 36.00 0.00" End="163.00 36.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="A" Start="163.00 322.00 0.00" End="163.00 322.00 -11.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1075.20 36.00 -18.00" End="1075.20 36.00 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="1075.20 322.00 -18.00" End="1075.20 322.00 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="777.20 36.00 -18.00" End="777.20 36.00 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="777.20 322.00 -18.00" End="777.20 322.00 -4.50" Diameter="15.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="163.00 68.00 -18.00" End="163.00 68.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <HoleV Name="" Face="B" Start="163.00 290.00 -18.00" End="163.00 290.00 -7.00" Diameter="10.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1466.40 24.50 -6.00" End="1293.40 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1287.30 24.50 -6.00" End="1114.30 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="945.35 24.50 -6.00" End="744.20 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="1108.20 24.50 -6.00" End="953.05 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="536.95 24.50 -6.00" End="738.10 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="374.10 24.50 -6.00" End="529.25 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="166.85 24.50 -6.00" End="368.00 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="A" Start="4.00 24.50 -6.00" End="159.15 24.50 -6.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1466.40 24.50 -12.00" End="1293.40 24.50 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="1287.30 24.50 -12.00" End="1114.30 24.50 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="374.10 24.50 -12.00" End="738.10 24.50 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="166.85 24.50 -12.00" End="368.00 24.50 -12.00" Width="6.00" IsCuted="0"/>
    <SlotL Name="" Face="B" Start="4.00 24.50 -12.00" End="159.15 24.50 -12.00" Width="6.00" IsCuted="0"/>
  </Plane>
</MicroDrawBan_XML>
`
// 五六面钻数据样例
export const tempDefaultStr = {
  BAN: ban,
  XML: xml,
  XML2: xml2,
  XML3: xml3,
  MPR: mpr,
  DXF: dxf,
  XINHONGTIAN: xinhongtian,
  PINMAI: pinmai,
  RUINUO: ruinuo,
  KAIHONG: kaihong,
  JIDONG: jidong,
  NANXINGFEIDA: nanxingfeida,
}
